import { Record } from 'immutable';

import type RotatableEntity from 'common/records/RotatableEntity';

export type CategoryTileSetType = {
  key?: string;
  heading?: string;
  tagline?: string;
  categoryTiles?: RotatableEntity;
};

export default Record<CategoryTileSetType>({
  key: undefined,
  heading: undefined,
  tagline: undefined,
  categoryTiles: undefined,
});
